/* Tarjetas de producto Reticare: elegir versión y añadir al carrito sin salir de la página (AX, 2026-09-23) */
(function () {
  function init(form) {
    if (form.dataset.rtReady) return;
    form.dataset.rtReady = '1';
    var btn = form.querySelector('[data-rt-add]');
    var status = form.querySelector('[data-rt-status]');
    var price = form.querySelector('[data-rt-price]');
    var data = form.querySelector('[data-rt-variants]');
    if (!btn || !data) return;
    var map = JSON.parse(data.textContent);
    function current() {
      var sel = form.querySelector('input[type=radio]:checked') || form.querySelector('input[type=hidden]');
      return sel ? map[sel.value] : null;
    }
    function refresh() {
      var v = current();
      btn.disabled = !v || !v.available;
      if (v && price) price.textContent = v.price;
      status.removeAttribute('data-state');
      status.textContent = v && !v.available ? form.dataset.soldout : '';
    }
    form.addEventListener('change', refresh);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var v = current();
      if (!v) return;
      var label = btn.textContent;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      btn.disabled = true;
      btn.textContent = form.dataset.adding;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        status.setAttribute('data-state', 'ok');
        status.innerHTML = '<a href="' + root + 'cart">' + form.dataset.added + '</a>';
        return fetch(root + 'cart.js').then(function (c) { return c.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'rt-card', data: { itemCount: cart.item_count } } }));
        });
      }).catch(function () {
        status.setAttribute('data-state', 'error');
        status.textContent = form.dataset.error;
      }).finally(function () {
        btn.textContent = label;
        refresh();
      });
    });
    refresh();
  }
  function all() { document.querySelectorAll('[data-rt-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
